import { render, staticRenderFns } from "./tab-pane-container.vue?vue&type=template&id=7b6122ac&"
import script from "./tab-pane-container.vue?vue&type=script&lang=js&"
export * from "./tab-pane-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports